import * as Models from "../shared/models";
import { CoreLogService } from "../services/log.service";
import { ModelManager } from "./modelManager";

/** spetzielle erweiterung des ModelManager's um Producte getrennt von dern ProductDetails zu laden */
export class ModelManagerProduct extends ModelManager<Models.ProductDataModel4> {

  public constructor(CoreLogService: CoreLogService) {
    super(Models.ProductDataModel4, CoreLogService);
  }

  // durch die Änderung des Nachladens (bei zugriff abgleich der ChangeAt) ist das nicht mehr notwendig (auskommentiert als Beispiel wenn wieder notwendig werden sollte)
  ///** overwritten to set fresh_details to false, it need to load product details */
  //protected prepareSyncDataModel(model: models.ProductDataModel3): void {
  //  super.prepareSyncDataModel(model);
  //
  //  model.fresh_details = false;
  //}

  // durch die Änderung des Nachladens (bei zugriff abgleich der ChangeAt) ist das nicht mehr notwendig (auskommentiert als Beispiel wenn wieder notwendig werden sollte)
  ///** overwritten to load ProductDetails (Attention: See also ProductDetailsHelperService.DownloadFaildProductDetails)
  // * @param keys Product.ID
  // */
  //public postLoadData(keys: (string | number)[], helper: CircularInjectionHelper): Promise<void> {
  //  // super not need to call
  //  const me = this;
  //  // Product kann wenn es mind. einem Standort zugeordnet ist, die Details abfragen
  //  return new Promise<void>((resolve, reject) => {
  //    if (helper.coreCOMService.environment.networkInformation.isOnline) {
  //      Utils.asyncForEach(keys, async (key) => {
  //        try {
  //          if (typeof (key) == "number") {
  //            const product = me.data_models[key];
  //            await ProductDetailsHelperService.GetProductDetails(product, helper, true, true);
  //            product.fresh_details = true;
  //            me.setInternModel(product);
  //          }
  //        } catch (error) {
  //          helper.coreLogService.error("ObjectObserver.postLoadData", "ProductDetailsHelperService.GetProductDetails", key, error);
  //        }
  //      }).then(resolve)
  //        .catch((error) => {
  //          helper.coreLogService.error("ObjectObserver.postLoadData", "asyncForEach", error);
  //          reject();
  //        });
  //    } else {
  //      // wenn offline, dann überspringen
  //      // ProductDetailsHelperService.DownloadFaildProductDetails wird es später nachladen
  //      resolve();
  //    }
  //  });
  //}

}
